// Copyright (c) Ensho Health, 2021 to present

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, generatePath } from 'react-router-dom';
import { Button, ButtonGroup } from '@blueprintjs/core';

import { useCheckMobileScreen } from '../../helper/useCheckMobileScreen.js';
import logo from '../../static/img/accelerate-black-and-white.png';
import LoginInfo from './LoginInfo.js';

import {
  StyledSubmitButton,
  StyledTitle,
  StyledError,
  StyledInput,
  StyledEnshoButton,
  StyledInputGroup,
  StyledImage,
  StyledForm
} from './FormLogin.styles.js';

export const form = 'FormLogin';

const FormLogin = (props) => {
  const [fields, setFields] = useState({
    email: '',
    password: ''
  });
  const isMobile = useCheckMobileScreen();
  const history = useHistory();

  const onFieldChange = (event) => {
    const field = event.target.name;
    setFields({ ...fields, [field]: event.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (fields.password && fields.email) {
      props.onSubmit(fields);
    }
  };
  const isFormDisabled = !fields.password || !fields.email || props.pushSent;
  function recoverPassword() {
    const newPath = generatePath(props.forgotPasswordLink);
    history.push(newPath);
  }

  return (
    <StyledForm onSubmit={onSubmit} isMobile={isMobile}>
      <div style={{ textAlign: 'left' }}>
        <StyledImage width="130" src={logo} alt="Compass Logo" />
      </div>
      <div style={{ border: '1px solid black' }}>
        <StyledTitle>Compass</StyledTitle>
        <StyledInputGroup>
          <StyledInput
            style={{ fontFamily: 'sohne', marginTop: 50 }}
            onChange={onFieldChange}
            defaultValue={fields.email}
            large={true}
            fill={true}
            type="email"
            name="email"
            placeholder="Email"
            intent={props.errorMessage ? 'danger' : ''}
          />
          <StyledInput
            style={{ fontFamily: 'sohne', marginTop: 20 }}
            onChange={onFieldChange}
            defaultValue={fields.password}
            large
            type="password"
            name="password"
            placeholder="Password"
            intent={props.errorMessage ? 'danger' : ''}
          />
          {props.errorMessage && (
            <StyledError>{props.errorMessage}</StyledError>
          )}
          {!props.pushSent && (
            <StyledSubmitButton
              style={{ fontFamily: 'sohne' }}
              loading={props.loading}
              intent="primary"
              disabled={isFormDisabled}
              type="submit"
            >
              Login
            </StyledSubmitButton>
          )}
        </StyledInputGroup>
        {props.pushSent && (
          <StyledEnshoButton intent="default">Push Sent</StyledEnshoButton>
        )}
        <div style={{ marginTop: 45 }}>
          <ButtonGroup fill={true} style={{ borderTop: '1px solid black' }}>
            <Button
              style={{
                padding: 22,
                fontSize: 14,
                fontFamily: 'sohne',
                borderRight: '1px solid black'
              }}
              minimal={true}
              fill={true}
              large={true}
              text="Recover password"
              onClick={recoverPassword}
            />
            <Button
              style={{ padding: 22, fontSize: 14, fontFamily: 'sohne' }}
              fill={true}
              large={true}
              minimal={true}
              disabled={true}
              text="Request an account"
            />
          </ButtonGroup>
        </div>
      </div>
      <LoginInfo />
    </StyledForm>
  );
};

FormLogin.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  errorMessage: PropTypes.string,
  forgotPasswordLink: PropTypes.string.isRequired,
  pushSent: PropTypes.bool
};

export default FormLogin;
